<template>
  <div class="content">
    <h1 class="title title--indent title--theme">
      <span v-if="$route.query.type === 'org'">Добавление благодарственного письма на организацию</span>
      <span v-else>Добавление индивидуального благодарственного письма</span>
    </h1>
    <form @submit.prevent>
      <app-grid class="grid--indent">
        <template #item-1>
          <template v-if="$route.query.type === 'org'">
            <app-form-group label="Название организации" label-for="org" required>
              <app-input
                v-model="form.org"
                id="org"
                placeholder="Введите значение"
                :error="$v.form.org.$error"
              />
              <template #error>
                <div v-if="$v.form.org.$dirty && !$v.form.org.required">Обязательное поле</div>
              </template>
            </app-form-group>
          </template>
          <template v-else>
            <app-form-group label="Фамилия" label-for="last_name" required>
              <app-input
                v-model="form.last_name"
                id="last_name"
                placeholder="Введите значение"
                :error="$v.form.last_name.$error"
              />
              <template #error>
                <div v-if="$v.form.last_name.$dirty && !$v.form.last_name.required">Обязательное поле</div>
              </template>
            </app-form-group>
            <app-form-group label="Имя" label-for="first_name" required>
              <app-input
                v-model="form.first_name"
                id="first_name"
                placeholder="Введите значение"
                :error="$v.form.first_name.$error"
              />
              <template #error>
                <div v-if="$v.form.first_name.$dirty && !$v.form.first_name.required">Обязательное поле</div>
              </template>
            </app-form-group>
            <app-form-group label="Отчество" label-for="patronymic" >
              <app-input
                v-model="form.patronymic"
                id="patronymic"
                placeholder="Введите значение"
              />
            </app-form-group>
          </template>
        </template>
        <template #item-2 v-if="$route.query.type !== 'org'">
          <app-form-group label="Должность" label-for="position" >
            <app-input
              v-model="form.position"
              id="position"
              placeholder="Введите значение"
            />
          </app-form-group>
          <app-form-group label="Название организации" label-for="org" >
            <app-input
              v-model="form.org"
              id="org"
              placeholder="Введите значение"
            />
          </app-form-group>
        </template>
      </app-grid>
      <app-cells>
        <app-button
          @click="onCheckForm('draft')"
          ref="submit"
          theme="transparent"
          :disabled="$v.form.$error"
        >
          Сохранить
        </app-button>
        <app-button
          @click="onCheckForm('review')"
          ref="submitSecond"
          :disabled="$v.form.$error"
        >
          Отправить на проверку
        </app-button>
      </app-cells>
    </form>
  </div>
</template>

<script>
import { postThankNote } from '@/http'
import { required, requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'CreateThankNote',
  data() {
    return {
      form: {}
    }
  },
  validations: {
    form: {
      first_name: {
        required: requiredIf(function() {
          return this.$route.query.type !== 'org'
        })
      },
      last_name: {
        required: requiredIf(function() {
          return this.$route.query.type !== 'org'
        })
      },
      org: {
        required: requiredIf(function() {
          return this.$route.query.type === 'org'
        })
      },
    }
  },
  methods: {
    onCheckForm(status) {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'warn',
          title: 'Внимание!',
          text: 'Проверьте правильность заполнения полей формы.'
        })
      } else {
        this.form.status_code = status
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      this.$refs.submitSecond.preload = true
      if (this.$route.query.type === 'org') this.form.type = 'org'
      else this.form.type = 'individual'
      postThankNote(this.form)
        .finally(() => {
          this.$refs.submit.preload = false
          this.$refs.submitSecond.preload = false
        })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Успех!',
            text: 'Благодарственное письмо добавлено'
          })
          this.$router.push({ name: 'thank-note-list' })
        })
    }
  }
}
</script>
